import React from 'react';

import { InfoLabel } from '@eika/label';

interface Props {
    label: string;
}

const TransactionCategoryLabel = ({ label }: Props) => <InfoLabel size="small" text={label} />;

export default TransactionCategoryLabel;
